import { z } from 'zod';

/**
 * F105 пака `tails-closeout` (С-I, WO-B1) — `?highlight=<audit_event_id>`: запись журнала, которую
 * панель «История изменений» открывает, прокручивает и выделяет. Подпись уровня 3 ведёт в саму
 * запись, а не во вкладку журнала целиком. Мусор в параметре — как отсутствие (`.catch`).
 */
export const AuditHighlightSearch = z.object({
  highlight: z.string().uuid().optional().catch(undefined),
});
export type AuditHighlightSearch = z.infer<typeof AuditHighlightSearch>;

export const validateAuditHighlight = (s: Record<string, unknown>): AuditHighlightSearch =>
  AuditHighlightSearch.parse(s);
